import { Card } from 'antd';
import { headerStyle } from 'shared/styles/baseStyle';
import EndPoints from 'shared/endPoints/EndPoints.json';
import useExcelUpload from 'shared/hooks/excel-upload-hook';
import UploadResults from './UploadResults';
import UploadModal from './UploadModal';

export default function UploadExcelEmissions() {
  const { fileList, successList, errorList, hasResults, handleChange } =
    useExcelUpload({
      successKey: 'succeededContracts',
      errorKey: 'failedContracts'
    });

  return (
    <Card
      type="inner"
      headStyle={headerStyle}
      title="Μεταφόρτωση Αρχείου Εκπομπών Excel"
      style={{ textAlign: 'center' }}
    >
      <UploadModal
        action={EndPoints.EXCEL.UPLOADEXCELEMISSIONS}
        onChange={handleChange}
        fileList={fileList}
        style={{ marginBottom: 20 }}
      />

      {hasResults && (
        <UploadResults
          title="Αποτελέσματα"
          successList={successList}
          errorList={errorList}
          successTitle="Επιτυχημένα Συμβόλαια"
          errorTitle="Αποτυχημένα Συμβόλαια"
        />
      )}
    </Card>
  );
}
